import React from 'react';
import { Link } from 'react-router-dom';
import BotPageLayout from '../../components/BotPageLayout';
import { IconCode, IconCheck, IconDiscord } from '../../components/Icons';
import './CodeAssist.css';

const STEPS = [
  { num: '01', title: 'Click Invite',        desc: 'Hit the invite button below to open the Discord OAuth2 authorisation flow.' },
  { num: '02', title: 'Select Your Server',  desc: 'Choose the server you want to add Code Assist to from the dropdown.' },
  { num: '03', title: 'Authorise',           desc: 'Review the required permissions, then click Authorise to complete setup.' },
  { num: '04', title: 'Start Coding',        desc: 'Use /help in your server to see all available commands and get started.' },
];

const PERMISSIONS = [
  { label: 'Send Messages',        allowed: true },
  { label: 'Read Message History', allowed: true },
  { label: 'Use Slash Commands',   allowed: true },
  { label: 'Embed Links',          allowed: true },
  { label: 'Administrator',        allowed: false },
  { label: 'Manage Server',        allowed: false },
];

const INVITE_URL = 'https://discord.com/api/oauth2/authorize?client_id=YOUR_CLIENT_ID&permissions=277025770560&scope=bot%20applications.commands';

export default function CodeAssistInvite() {
  return (
    <BotPageLayout
      botName="Code Assist"
      botSlug="code-assist"
      botIcon={<IconCode size={28} color="var(--blue-dark)" />}
      botTagline="Write, debug, and optimise code without leaving your Discord server."
    >
      <div className="container">
        <div className="ca-invite-hero animate-fade-up">
          <div className="ca-invite-hero__icon-wrap">
            <IconCode size={36} color="var(--blue-dark)" />
          </div>
          <h2 className="section-title">Add Code Assist to your server</h2>
          <p className="section-body" style={{ textAlign: 'center', margin: '12px auto 0' }}>
            Free to use. No credit card required. Up and running in under a minute.
          </p>
          <div className="ca-invite-hero__btns">
            <a href={INVITE_URL} target="_blank" rel="noopener noreferrer"
               className="btn btn--primary btn--lg">
              Invite Code Assist
            </a>
            <Link to="/support-server" className="btn btn--outline btn--lg">
              <IconDiscord size={16} />
              Need Help?
            </Link>
          </div>
          <p className="ca-invite-hero__note">
            By inviting, you agree to our{' '}
            <Link to="/terms">Terms of Service</Link> and{' '}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>

        <div style={{ marginTop: 72 }}>
          <h3 className="ca-commands-title animate-fade-up">How to invite</h3>
          <div className="ca-steps animate-fade-up delay-1">
            {STEPS.map(({ num, title, desc }) => (
              <div key={num} className="ca-step">
                <span className="ca-step__num">{num}</span>
                <div>
                  <h4>{title}</h4>
                  <p>{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="ca-permissions animate-fade-up" style={{ marginTop: 56 }}>
          <h3 className="ca-commands-title">Required Permissions</h3>
          <p className="ca-commands-sub">
            Code Assist requests only the minimum permissions it needs.
            It will never request Administrator or Manage Server access.
          </p>
          <div className="ca-permissions__grid">
            {PERMISSIONS.map(({ label, allowed }) => (
              <div key={label} className={`ca-perm${allowed ? '' : ' ca-perm--denied'}`}>
                <div className={`ca-perm__icon ${allowed ? 'ca-perm__icon--ok' : 'ca-perm__icon--no'}`}>
                  {allowed
                    ? <IconCheck size={11} color="#1a9a5c" />
                    : <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#c0392b' }}>x</span>
                  }
                </div>
                {label}
              </div>
            ))}
          </div>
        </div>

        <div className="ca-cta-strip animate-fade-up" style={{ marginTop: 56 }}>
          <p>Having trouble? Our team is ready to assist.</p>
          <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer"
             className="btn btn--dark">
            <IconDiscord size={15} />
            Join Support Server
          </a>
        </div>
      </div>
    </BotPageLayout>
  );
}